import React from "react";
import Header from "../../Common/Header/header";
import Sidebar from "../../Common/Sidebar/sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import isGHMC from "../../Common/helper/helpar";

const ViewVehicleTypeDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const vehicleTypeData = location.state;
  const vehicleStatus = vehicleTypeData.status === "1" ? "Active" : "InActive";
  const isProd = isGHMC();

  return (
    <div style={{ width: "100%" }} className={`${isProd ? "ghmc-true" : "ghmc-false"} App`}>
      <Header />
      <Sidebar />
      <div className="content">
        <div className="page-content">
          <div
            className="page-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h4 style={{ display: "flex", marginTop: "10px" }}>
              View Vehicle Type Details
            </h4>
            <button
              className="btn btn-danger"
              style={{
                display: "flex",
                width: "80px",
                height: "35px",
                fontSize: "15px",
                justifyContent: "center",
                marginTop: "10px",
                backgroundColor: "rgb(236, 17, 23)",
              }}
              onClick={() => navigate("/vehicle-type")}
            >
              Back
            </button>
          </div>
          <div className="card">
            <div className="p-3">
              <form>
                <div className="row" style={{ textAlign: "justify" }}>
                  <div className="col-md-4 mb-3">
                    <div className="form-group">
                      <label className="form-label">Vehicle Type Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={vehicleTypeData.name}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="form-group">
                      <label className="form-label">
                        Vehicle Category Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={vehicleTypeData.category}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="form-group">
                      <label className="form-label">Status</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={vehicleStatus} // Render status based on its value
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewVehicleTypeDetails;
